import { AxiosError } from 'axios'
import { UseFormSetError } from 'react-hook-form/dist/types/form'
import { Path } from 'react-hook-form'
import { FieldValues } from 'react-hook-form/dist/types/fields'

export interface ErrorResponse extends Error {
  non_field_errors: string[]
}

export interface AxiosErrorHandlerConfig<T> {
  excludeFields?: string[]
  nonFieldErrorsAs?: Path<T>
  showGlobalError?: boolean
}

export const useAxiosErrorHandler = <TFieldValues extends FieldValues>(): ((...params) => void) => {
  const initialConfiguration: AxiosErrorHandlerConfig<TFieldValues> = { excludeFields: [], showGlobalError: true }

  return (
    error: AxiosError<ErrorResponse>,
    setErrors: UseFormSetError<TFieldValues>,
    configuration: AxiosErrorHandlerConfig<TFieldValues> = initialConfiguration,
  ) => {
    if (!configuration.excludeFields) {
      configuration.excludeFields = []
    }
    if (configuration.nonFieldErrorsAs) {
      configuration.excludeFields.push('non_field_errors')
    }
    if (error.response?.status === 400) {
      if (error.response.data.non_field_errors && configuration.nonFieldErrorsAs) {
        setErrors(configuration.nonFieldErrorsAs, {
          type: 'server',
          message: Array.isArray(error.response.data.non_field_errors)
            ? error.response.data.non_field_errors.join('. ')
            : error.response.data.non_field_errors,
        })
      }

      Object.keys(error.response.data).map((key: Path<TFieldValues>) => {
        if (!configuration.excludeFields?.includes(key)) {
          const message = error.response?.data[key as string]
          if (typeof message[0] === 'object') {
            handleAxiosFormErrorsNestedObject(key, message, setErrors)
          } else {
            setErrors(key, {
              type: 'server',
              message: (message || []).join('. '),
            })
          }
        }
      })
    }
  }
}

const handleAxiosFormErrorsNestedObject = (fieldName, message, setErrors) => {
  message.map((validation, index) => {
    Object.keys(validation).map(key => {
      const newKey = `${fieldName}.${index}.${key}`
      setErrors(newKey, {
        type: 'server',
        message: validation[key].join('. '),
      })
    })
  })
}
